import React, { useRef } from "react";

import { motion } from "framer-motion";

const OurBenefits = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const sectionRef = useRef(null);

  return (
    <div ref={sectionRef} className={`col-xxl-6 col-xl-6 col-lg-6 col-md-12`}>
      <div className="benefit-wrape">
        <div className="head-wrape">
          <motion.h2 className={`head animate-child`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            custom={0.1}
            variants={fadeUpVariant}
          >Who We Are</motion.h2>
          <motion.h1 className={`animate-child`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            custom={0.1}
            variants={fadeUpVariant}
          >Orex Trade Network connects buyers, suppliers and logistics partners worldwide</motion.h1>
          <motion.p className={`animate-child`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            custom={0.1}
            variants={fadeUpVariant}
          >
            Since 2015, we’ve been helping businesses simplify trade by building trusted connections, sharing market insights and offering reliable tools to grow globally. Our network is designed to make international trade smarter, faster and more secure.
          </motion.p>
        </div>
        <div className={`row`}>
          <div className={`col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12`}>
            <motion.div className="benefit animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
              custom={0.1}
              variants={fadeUpVariant}
            >
              <div className="icon buyer">
                <i className="sprite"></i>
              </div>
              <div className="detail">
                <h6>
                  Buyer/Supplier Details Access
                </h6>
              </div>
            </motion.div>
          </div>

          <div className={`col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12`}>
            <motion.div className="benefit animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
              custom={0.1}
              variants={fadeUpVariant}
            >
              <div className="icon shipment">
                <i className="sprite"></i>
              </div>
              <div className="detail">
                <h6>
                  Shipment Analytics
                </h6>
              </div>
            </motion.div>
          </div>

          <div className={`col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12`}>
            <motion.div className="benefit animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
              custom={0.1}
              variants={fadeUpVariant}
            >
              <div className="icon lead">
                <i className="sprite"></i>
              </div>
              <div className="detail">
                <h6>
                  Lead Access
                </h6>
              </div>
            </motion.div>
          </div>

          <div className={`col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12`}>
            <motion.div className="benefit animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
              custom={0.1}
              variants={fadeUpVariant}
            >
              <div className="icon hsn">
                <i className="sprite"></i>
              </div>
              <div className="detail">
                <h6>
                  HSN Code Access
                </h6>
              </div>
            </motion.div>
          </div>

          <div className={`col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12`}>
            <motion.div className="benefit animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
              custom={0.1}
              variants={fadeUpVariant}
            >
              <div className="icon customer">
                <i className="sprite"></i>
              </div>
              <div className="detail">
                <h6>
                  Customer Support
                </h6>
              </div>
            </motion.div>
          </div>

          <div className={`col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12`}>
            <motion.div className="benefit animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
              custom={0.1}
              variants={fadeUpVariant}
            >
              <div className="icon global">
                <i className="sprite"></i>
              </div>
              <div className="detail">
                <h6>
                  Global Coverage
                </h6>
              </div>
            </motion.div>
          </div>

          <div className={`col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12`}>
            <motion.div className="benefit animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
              custom={0.1}
              variants={fadeUpVariant}
            >
              <div className="icon customized">
                <i className="sprite"></i>
              </div>
              <div className="detail">
                <h6>
                  Customized Business Landing Page
                </h6>
              </div>
            </motion.div>
          </div>

          <div className={`col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12`}>
            <motion.div className="benefit animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
              custom={0.1}
              variants={fadeUpVariant}
            >
              <div className="icon exclusive">
                <i className="sprite"></i>
              </div>
              <div className="detail">
                <h6>
                  Exclusive Logistics
                </h6>
              </div>
            </motion.div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default React.memo(OurBenefits);
